var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1666 4.6665L9.18658 8.4665C8.98077 8.59545 8.7428 8.66384 8.49992 8.66384C8.25704 8.66384 8.01907 8.59545 7.81325 8.4665L1.83325 4.6665M3.16659 2.6665H13.8333C14.5696 2.6665 15.1666 3.26346 15.1666 3.99984V11.9998C15.1666 12.7362 14.5696 13.3332 13.8333 13.3332H3.16659C2.43021 13.3332 1.83325 12.7362 1.83325 11.9998V3.99984C1.83325 3.26346 2.43021 2.6665 3.16659 2.6665Z",
    stroke: "#FAFAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.736d9370f537ea2eb7f11dea3df526ab.svg";
export { ForwardRef as ReactComponent };